'use strict'

// Constants
import {CATEGORY_ID_WOMEN_SWIMWEAR_BIKINIS, PROD_ATTR_CODE_LIGNE_PROD} from '../constants'

/**
 * Extends the list of excluded filters based on specific category conditions.
 *
 * This function checks if the given parameters match a specific category ID
 * and if a particular product attribute code is not already in the list of
 * excluded filters. If both conditions are met, it adds the product attribute
 * code to the excluded filters list.
 *
 * @param {Object} params - The parameters object containing various properties.
 * @param {string} params.categoryId - The category ID to be checked against a specific value.
 * @param {Array} excludedFiltersList - The list of filters that are currently excluded.
 */
export const extendRefinementExclusions = (params, excludedFiltersList) => {
    /*
        Special Case: orliweb_code_ligne_produit refinement is not blocked from Business Manager, 
        since it is needed for automatic linking functionality so we are not displaying it in the UI by
        extending the EXCLUDED_FILTERS_LIST.
        More details -> https://docs.google.com/document/d/1rAMEzOe0EfcUCndQygncKpjp6XoEkT-PVhDqllmgRqo/edit?tab=t.0#heading=h.yc9wrngdnxfp
    */
    if (
        params.categoryId === CATEGORY_ID_WOMEN_SWIMWEAR_BIKINIS &&
        !excludedFiltersList.includes(PROD_ATTR_CODE_LIGNE_PROD)
    ) {
        excludedFiltersList.push(PROD_ATTR_CODE_LIGNE_PROD)
    } else if (
        params.categoryId !== CATEGORY_ID_WOMEN_SWIMWEAR_BIKINIS &&
        excludedFiltersList.includes(PROD_ATTR_CODE_LIGNE_PROD)
    ) {
        excludedFiltersList.splice(excludedFiltersList.indexOf(PROD_ATTR_CODE_LIGNE_PROD), 1)
    }
}
